import Analytics from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';
export const GTM_CONTAINER_ID = 'GTM-542KDC4P';
export const analytics = Analytics({
  app: 'mannix-senior-living-lp',
  plugins: [googleTagManager({
    containerId: GTM_CONTAINER_ID
  })]
});
